'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _translate = require('../../language/translate');

var _BackButtonComponent = require('../../components/input/BackButtonComponent');

var _BackButtonComponent2 = _interopRequireDefault(_BackButtonComponent);

var _SubmitButtonComponent = require('../../components/input/SubmitButtonComponent');

var _SubmitButtonComponent2 = _interopRequireDefault(_SubmitButtonComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/prefer-stateless-function */

/**
 * Renders the top portion of the form which persists between form pages.
 * @extends {Component}
 */
var HeaderComponent = function (_React$Component) {
  _inherits(HeaderComponent, _React$Component);

  function HeaderComponent() {
    _classCallCheck(this, HeaderComponent);

    return _possibleConstructorReturn(this, (HeaderComponent.__proto__ || Object.getPrototypeOf(HeaderComponent)).apply(this, arguments));
  }

  _createClass(HeaderComponent, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactBootstrap.Col,
        { xs: 12, className: 'application-form-buttons div-center' },
        _react2.default.createElement(
          _BackButtonComponent2.default,
          { isFormSubmitting: this.props.submitting || this.props.pendingPayment, onClick: this.props.back },
          (0, _translate.t)('Previous')
        ),
        ' ',
        _react2.default.createElement(
          _SubmitButtonComponent2.default,
          {
            isFormSubmitting: this.props.submitting,
            isFormInvalid: false
          },
          (0, _translate.t)('Buy Now')
        )
      );
    }
  }]);

  return HeaderComponent;
}(_react2.default.Component);

HeaderComponent.propTypes = {
  submitting: _react2.default.PropTypes.func.isRequired,
  back: _react2.default.PropTypes.func.isRequired,
  pendingPayment: _react2.default.PropTypes.bool
};
exports.default = HeaderComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/common/CompleteApplicationButtons.jsx
// module id = 1660
// module chunks = 0